import { clearAllData } from './secureStorage';

/**
 * Reusable logout utility that clears all auth data.
 * Note: Navigation is handled by the caller so the correct login route and history replacement can be used.
 * @param showToast - Optional function to show toast message
 */
export const logoutUser = async (
  showToast?: (message: string, type: 'success' | 'error' | 'warning') => void
): Promise<void> => {
  try {
    // Clear all storage
    await clearAllData();
    localStorage.clear();
    sessionStorage.clear();

    if (showToast) {
      showToast('You have been logged out successfully', 'success');
    }
  } catch (error) {
    console.error('Logout cleanup error:', error);
    if (showToast) {
      showToast('Logout failed', 'error');
    }
  }
};